module.exports = __webpack_public_path__ + "img/B2.8f48cb0a.svg";